import ApiClient from './ApiClient';

class BreakReasonsAPI extends ApiClient {
  constructor() {
    super('break_reasons', { accountScoped: true, apiVersion: 'v2' });
  }
}

export default new BreakReasonsAPI();
